import './App.css';
import Products from './Components/Products.js/Products';

function App() {
  return (
    <div>
      <Products />
    </div>
  );
}

export default App;
